<template>
    <b-col md="6">
        <b-form-group>
            <b-row no-gutters>
                <b-col>
                    <label>{{ label }}</label>
                    <v-select
                        v-model="selectedId"
                        :options="options"
                        label="name"
                        :reduce="(item) => item.id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    />
                </b-col>

                <b-col class="px-1">
                    <label>Distance (m.)</label>
                    <b-form-input
                        v-model="distance"
                        placeholder="Distance (m.)"
                    />
                </b-col>

                <b-col class="px-1">
                    <label>Duration (min.)</label>
                    <b-form-input
                        v-model="duration"
                        placeholder="Duration (min.)"
                    />
                </b-col>

                <b-col cols="auto" class="d-flex align-items-end">
                    <b-button variant="outline-primary" @click="addItem">
                        Add
                    </b-button>
                </b-col>
            </b-row>

            <div
                class="d-flex justify-content-between mt-1"
                v-for="(item, index) in data"
                :key="index"
            >
                <div class="text-left w-100">{{ getName(item.transitId) }}</div>
                <div class="text-left w-100">{{ item.distance }} m.</div>
                <div class="text-left w-100">{{ item.duration }} min.</div>
                <div>
                    <b-badge variant="danger" @click="removeItem(index)">
                        <feather-icon icon="XIcon" />
                    </b-badge>
                </div>
            </div>
        </b-form-group>
    </b-col>
</template>

<script>
import { BFormGroup, BRow, BCol, BFormInput, BButton, BBadge } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
    name: 'LocationSelector',
    components: { BFormGroup, BRow, BCol, BFormInput, BButton, BBadge, vSelect },
    props: {
        label: { type: String, required: true },
        options: { type: Array, required: true },
        data: { type: Array, required: true }
    },
    data() {
        return {
            selectedId: null,
            distance: null,
            duration: null
        }
    },
    methods: {
        addItem() {
            if (!this.selectedId || !this.distance || !this.duration) return
            this.data.push({ transitId: this.selectedId, distance: this.distance, duration: this.duration })
            this.selectedId = null
            this.distance = null
            this.duration = null
        },
        removeItem(index) {
            this.data.splice(index, 1)
        },
        getName(id) {
            const found = this.options.find(o => o.id === id)
            return found ? found.name : null
        }
    }
}
</script>